import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UnsubscribeAddress } from '../model/unsubscribe-address';
import { HttpCommonService } from './http-common.service';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {

  private apiUrl = environment.api + '/UnsubscribeEmail';

  constructor(
    private http: HttpClient,
    private httpCommonService: HttpCommonService
  ) { }

  emailUnsubscribe(emailAddress: string, projectId: number){
    const unsubscribe: UnsubscribeAddress = {
      StakeEmail: emailAddress,
      ProjectId: projectId
    };
    return this.http.post<UnsubscribeAddress>(this.apiUrl, unsubscribe).pipe(
      tap((response: UnsubscribeAddress) => console.log(`unsubscribed email =${response.StakeEmail}`)),
      catchError(this.httpCommonService.basicErrorHandler)
    );
  }

}
